// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import Image from 'components/Image';
import {LayoutCenterMiddle, LayoutWrapper} from 'components/Layout';
import {useLocalized} from 'components/Localized';
import Logo from 'components/Logo';
import SoundToggleButton from 'components/SoundToggleButton';
import {ButtonNextPageBlack} from 'components/ButtonNextPage';
import * as VideoUtils from 'utils/videoUtils';
import Disclaimer from 'components/Disclaimer'
import * as AudioUtils from 'utils/audioUtils';

type Props = {
  nextPath?: string,
}

export default function Intro(props: Props): React.Element<any> {
  const history = useHistory();
  const localized = useLocalized();
  
  const nodeRef = React.useRef(null);
  const [videoPlaying, setVideoPlaying] = React.useState(true);

  React.useEffect(()=>{
    window.tagManager.introPage();
  },[]);

  React.useEffect(()=>{

    AudioUtils.stopBGM();
    function updateVisibility() {
      if (nodeRef.current !== null) {
        if (videoPlaying !== VideoUtils.isPlaying()) {
          setVideoPlaying(VideoUtils.isPlaying());
        }
      }
    }

    let checkVideoStateTimer = window.setInterval(updateVisibility, 1000);
    try {
    }
    catch(e) {
      console.log(e);
    }
    
    return ()=>{
      if (checkVideoStateTimer != null) {
        window.clearInterval(checkVideoStateTimer);
        checkVideoStateTimer = null;
      }
    };
  }, [videoPlaying]);

  React.useEffect(()=>{

    VideoUtils.loadIntro();
    VideoUtils.onEnd(()=>{
      history.push(props.nextPath);
    });
    
    try {
      VideoUtils.play();
    }
    catch(e) {
      console.log(e);
    }

    return ()=>{
      VideoUtils.unload();
    };
    
  }, [history, props.nextPath]);

  return (
    <main>
      <Wrapper></Wrapper>
      <DivPlayButton videoPlaying={videoPlaying}>
        <button
          ref={nodeRef}
          onClick={() => {
            console.log('play');
            VideoUtils.play();
            setVideoPlaying(true);
          }}>
          <Image source="./home/btn-play.png" />
        </button>
      </DivPlayButton>
      <SoundToggleButton onClick={ ()=>{
        window.tagManager.introSoundLinkClick();
      }} />
      <ButtonNextPageBlack
        title={localized.tutorial_p00_intro_001}
        onNext={() => {
          history.push(props.nextPath);
          VideoUtils.loadTutorialBG();
          VideoUtils.play();
          window.tagManager.introSkipLinkClick();
        }}
      />
      <Logo />
      <Disclaimer textKey="disclaimer_default" />
    </main>
  );
}

const Wrapper = styled(LayoutWrapper)`
  text-align: center;
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;
  
  color: #ffffff;
`;

const DivPlayButton = styled(LayoutCenterMiddle)`
  button {
    width: ${props => props.theme.layout.mobile ? 68 : 80}px;
    height: ${props => props.theme.layout.mobile ? 68 : 80}px;
    visibility: ${props => props.videoPlaying ? "hidden":""};
  }
`;